export const Testimonials = () => (
  <section data-testid="testimonials-section" className="py-16 px-6 border-b border-[#1e2335]">
    <div className="max-w-4xl mx-auto rounded-2xl bg-[#0e101a] border border-dashed border-[#2b314a] p-8 text-center space-y-3">
      <span className="text-xs font-mono-code text-[#818cf8] uppercase tracking-widest">FEEDBACK DEI REGISTI</span>
      <h3 className="text-xl font-disp font-bold text-white">Testimonianze &amp; Recensioni</h3>
      <p className="font-serif-body text-sm text-[#94a3b8] max-w-md mx-auto">
        Le testimonianze dei registi e delle produzioni con cui collaborer&ograve; appariranno qui.
      </p>
    </div>
  </section>
);
